import { initGraphQLTada } from 'gql.tada'
import type { introspection } from './user-env'

export const graphql = initGraphQLTada<{
    introspection: introspection
}>()